import { money, formatDate, escapeHtml } from "./settlementFormatters";

// =========================================================
// Build receipt HTML
// =========================================================

const buildSettlementHtml = (item) => {
  const remaining = Number(item.remainingAmount || 0);
  const remainingLabel = remaining < 0 ? "مستحق للمندوب" : remaining === 0 ? "تم التقفيل" : "متبقي على المندوب";
  const remainingValue = money(Math.abs(remaining));

  return `
      <!DOCTYPE html>
      <html lang="ar" dir="rtl">
        <head>
          <meta charset="UTF-8" />
          <title>تسوية ${escapeHtml(item.representativeName)} - ${formatDate(item.settlementDate)}</title>
          <style>
            * { box-sizing: border-box; }
            body { font-family: Tahoma, Arial, sans-serif; padding: 32px; color: #1e293b; }
            h1 { font-size: 20px; margin-bottom: 4px; }
            .sub { color: #64748b; font-size: 13px; margin-bottom: 24px; }
            table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
            td, th { border: 1px solid #e2e8f0; padding: 10px 12px; font-size: 13px; text-align: right; }
            th { background: #f8fafc; width: 40%; }
            .section-title { font-weight: bold; margin: 20px 0 8px; font-size: 15px; }
            .highlight { background: #eff6ff; font-weight: bold; }
            .notes { border: 1px solid #e2e8f0; padding: 12px; border-radius: 8px; background: #f8fafc; font-size: 13px; }
            @media print { body { padding: 12px; } }
          </style>
        </head>
        <body>
          <h1>إيصال تسوية مندوب</h1>
          <div class="sub">تاريخ الطباعة: ${new Date().toLocaleString("ar-EG")}</div>

          <table>
            <tr><th>المندوب</th><td>${escapeHtml(item.representativeName)}</td></tr>
            <tr><th>تاريخ التسوية</th><td>${formatDate(item.settlementDate)}</td></tr>
            <tr><th>إجمالي الفواتير</th><td>${item.totalHandedInvoicesCount ?? 0}</td></tr>
            <tr><th>إجمالي المبلغ</th><td>${money(item.totalHandedAmount)} ج.م</td></tr>
          </table>

          <div class="section-title">تفاصيل الفواتير</div>
          <table>
            <tr><th>تم التسليم</th><td>${item.deliveredInvoicesCount ?? 0} فاتورة - ${money(item.deliveredAmount)} ج.م</td></tr>
            <tr><th>المرتجع</th><td>${item.returnedInvoicesCount ?? 0} فاتورة - ${money(item.returnedAmount)} ج.م</td></tr>
            <tr><th>المعلّق</th><td>${item.pendingInvoicesCount ?? 0} فاتورة - ${money(item.pendingAmount)} ج.م</td></tr>
          </table>

          <div class="section-title">التفاصيل المالية</div>
          <table>
            <tr><th>الشحن</th><td>${money(item.shippingAmount)} ج.م</td></tr>
            <tr><th>صافي المطلوب</th><td>${money(item.netRequiredAmount)} ج.م</td></tr>
            <tr><th>كاش</th><td>${money(item.cashAmount)} ج.م</td></tr>
            <tr><th>InstaPay</th><td>${money(item.instaPayAmount)} ج.م</td></tr>
            <tr><th>Vodafone Cash</th><td>${money(item.vodafoneCashAmount)} ج.م</td></tr>
            <tr class="highlight"><th>إجمالي المدفوع</th><td>${money(item.paidAmount)} ج.م</td></tr>
            <tr class="highlight"><th>${remainingLabel}</th><td>${remainingValue} ج.م</td></tr>
            <tr><th>الحالة</th><td>${escapeHtml(item.status) || "-"}</td></tr>
          </table>

          ${item.notes ? `<div class="section-title">ملاحظات</div><div class="notes">${escapeHtml(item.notes)}</div>` : ""}
        </body>
      </html>
    `;
};

// =========================================================
// Print Settlement (PDF via browser print dialog)
// Returns false لو المتصفح منع النافذة المنبثقة
// =========================================================

export const printSettlement = (item) => {
  const printWindow = window.open("", "_blank", "width=800,height=900");
  if (!printWindow) return false;

  printWindow.document.open();
  printWindow.document.write(buildSettlementHtml(item));
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
  };

  return true;
};